var React = require('react');

function ServiceMarketing (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 19.185h4.741V34H2zM10.889 12.667h4.741V34h-4.741zM19.778 15.629h4.741v18.37h-4.741zM28.666 6.74h4.741v27.259h-4.741z"}));
}

ServiceMarketing.defaultProps = {"viewBox":"0 0 36 36"};

module.exports = ServiceMarketing;

ServiceMarketing.default = ServiceMarketing;
